import { IUserMilestone } from '../../IUserMilestone';

/**
 * Retailer should be shown one-off limit increase modal
 */
export const ONE_OFF_LIMIT_INCREASE_MODAL_VIEW =
  'ONE_OFF_LIMIT_INCREASE_MODAL_VIEW' as IUserMilestone.RetailerMilestone;
